import getCombatantIndexById from './getCombatantIndexById'
import store from '../store/index'
import pendingAction from '../assets/images/bbPendingAction.png'
//----------------
// set pending CA
//----------------
export default function setPendingCA(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants
  //-------------------
  // get combatant idx
  //-------------------
  let i = getCombatantIndexById(parm.id)
  // if (i > -1) {
  //------------------
  // set var ca props
  //------------------
  let ca = 'ca' + parm.ca_num
  let ca_name = 'ca_name' + parm.ca_num
  let ca_slug = 'ca_slug' + parm.ca_num
  let ca_type = 'ca_type' + parm.ca_num
  //------------------
  // set pending slot
  //------------------
  combatants[i][ca] = pendingAction
  combatants[i][ca_name] = 'pending'
  combatants[i][ca_slug] = ''
  combatants[i][ca_type] = ''
  // }
}
